import { createSelector } from '@reduxjs/toolkit'

import { referencesSelectors } from './references'

const schedulePageState = (state) => state.schedulePage

const isSelectedValueValid = (selectedId, options) => {
    if (!selectedId) return false

    return options.some((option) => String(option.value) === String(selectedId))
}

const selectScheduleFilters = createSelector(
    [
        (state) => schedulePageState(state).viewMode,
        (state) => schedulePageState(state).selectedGroupId,
        (state) => schedulePageState(state).selectedTeacherId,
        (state) => schedulePageState(state).dateFrom,
        (state) => schedulePageState(state).dateTo,
        (state) => schedulePageState(state).selectedRoomId,
        (state) => schedulePageState(state).selectedBuildId,
        (state) => schedulePageState(state).selectedClassTypeId,
        (state) => schedulePageState(state).selectedSubjectId,
        (state) => schedulePageState(state).currentPage,
        (state) => schedulePageState(state).pageSize,
    ],
    (
        viewMode,
        selectedGroupId,
        selectedTeacherId,
        dateFrom,
        dateTo,
        selectedRoomId,
        selectedBuildId,
        selectedClassTypeId,
        selectedSubjectId,
        currentPage,
        pageSize
    ) => ({
        viewMode,
        selectedGroupId,
        selectedTeacherId,
        dateFrom,
        dateTo,
        selectedRoomId,
        selectedBuildId,
        selectedClassTypeId,
        selectedSubjectId,
        currentPage,
        pageSize,
    })
)

export const schedulePageSelectors = {
    dateFrom: (state) => schedulePageState(state).dateFrom,
    dateTo: (state) => schedulePageState(state).dateTo,
    viewMode: (state) => schedulePageState(state).viewMode,
    selectedGroupId: (state) => schedulePageState(state).selectedGroupId,
    selectedTeacherId: (state) => schedulePageState(state).selectedTeacherId,
    selectedRoomId: (state) => schedulePageState(state).selectedRoomId,
    selectedBuildId: (state) => schedulePageState(state).selectedBuildId,
    selectedClassTypeId: (state) => schedulePageState(state).selectedClassTypeId,
    selectedSubjectId: (state) => schedulePageState(state).selectedSubjectId,
    selectedExportGroupId: (state) => schedulePageState(state).selectedExportGroupId,
    selectedExportGroupName: (state) => schedulePageState(state).selectedExportGroupName,
    exportModalOpen: (state) => schedulePageState(state).exportModalOpen,
    error: (state) => schedulePageState(state).error,
    saveOnServer: (state) => schedulePageState(state).saveOnServer,
    currentPage: (state) => schedulePageState(state).currentPage,
    pageSize: (state) => schedulePageState(state).pageSize,
    showMoreOptions: (state) => schedulePageState(state).showMoreOptions,
    filters: selectScheduleFilters,
    isValidGroupValue: (state) =>
        isSelectedValueValid(
            schedulePageState(state).selectedGroupId,
            referencesSelectors.groupOptions(state)
        ),
    isValidTeacherValue: (state) =>
        isSelectedValueValid(
            schedulePageState(state).selectedTeacherId,
            referencesSelectors.teacherOptions(state)
        ),
}
